import { useI18n } from "@/i18n/I18nProvider";

/**
 * PlatformRules — one visual card that recaps every platform rule at a glance.
 * Placed after PartnerPhoneDemo, before the FAQ. 7 short rules in a grid.
 * The rules are the same the user asked us to communicate in the MVP brief:
 * verified registries, free sign-up, no monthly fee, commission on success
 * only, direct payment in phase 1, Marche first, future integrated payments.
 */
export default function PlatformRules() {
    const { t } = useI18n();
    const rules = [1, 2, 3, 4, 5, 6].map((n) => ({
        n,
        title: t(`rules.r${n}.title`),
        body: t(`rules.r${n}.body`),
    }));

    return (
        <section
            id="regole"
            data-testid="platform-rules"
            data-reveal="up"
            style={{
                padding: "96px 32px 88px",
                background: "var(--itly-surface)",
                borderTop: "1px solid var(--itly-border)",
                borderBottom: "1px solid var(--itly-border)",
            }}
        >
            <div style={{ maxWidth: 1160, margin: "0 auto" }}>
                <div style={{ textAlign: "center", marginBottom: 48 }}>
                    <div className="itly-badge">{t("rules.badge")}</div>
                    <h2
                        style={{
                            fontFamily: "Fraunces, serif",
                            fontSize: "clamp(32px, 4vw, 52px)",
                            lineHeight: 1.05,
                            color: "var(--itly-fg-strong)",
                            marginTop: 20,
                            marginBottom: 18,
                            letterSpacing: "-0.01em",
                        }}
                    >
                        {t("rules.title_a")}{" "}
                        <em style={{ color: "var(--itly-orange-500)", fontStyle: "italic" }}>
                            {t("rules.title_b")}
                        </em>
                    </h2>
                    <p
                        style={{
                            maxWidth: 660,
                            margin: "0 auto",
                            fontFamily: "Inter, sans-serif",
                            fontSize: 16,
                            lineHeight: 1.65,
                            color: "var(--itly-muted)",
                        }}
                    >
                        {t("rules.sub")}
                    </p>
                </div>

                <div
                    className="itly-rules-grid"
                    style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
                        gap: 16,
                    }}
                >
                    {rules.map((r) => (
                        <article
                            key={r.n}
                            data-testid={`rule-${r.n}`}
                            style={{
                                background: "var(--itly-cream)",
                                border: "1px solid var(--itly-border)",
                                borderRadius: 16,
                                padding: "22px 22px 20px",
                                display: "flex",
                                flexDirection: "column",
                                gap: 10,
                            }}
                        >
                            <div
                                aria-hidden="true"
                                style={{
                                    fontFamily: "Fraunces, serif",
                                    fontSize: 30,
                                    lineHeight: 1,
                                    color: "var(--itly-orange-500)",
                                    letterSpacing: "-0.02em",
                                    fontWeight: 700,
                                }}
                            >
                                0{r.n}
                            </div>
                            <h3
                                style={{
                                    fontFamily: "Fraunces, serif",
                                    fontSize: 19,
                                    lineHeight: 1.25,
                                    color: "var(--itly-fg-strong)",
                                    margin: 0,
                                    letterSpacing: "-0.005em",
                                }}
                            >
                                {r.title}
                            </h3>
                            <p
                                style={{
                                    fontFamily: "Inter, sans-serif",
                                    fontSize: 13.5,
                                    lineHeight: 1.55,
                                    color: "var(--itly-muted)",
                                    margin: 0,
                                }}
                            >
                                {r.body}
                            </p>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}
